import {
    apiRequest,
    salaryDetail,
    salaryUpdate,
    pangkatList
} from "../../../../../services/adapters/master/salaryService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", salaryDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", salaryUpdate, {
            body: query
        }, true)
    }

    fetchRank = async (query) => {
        return await apiRequest("get", pangkatList, {
            params: query
        }, true)
    }
}

export default UpdateRepository